const entries = [
  {
    date: "Lesedauer: 1 Sekunde",
    cat: "kurz",
    title: "Interessenten sind keine Brieftauben",
    excerpt:
      "Sie rufen an.",
    img: "https://public.readdy.ai/ai/img_res/edited_29ff06822b54d7404b10ac76fc32f2e1_c5c8d7fd.jpg",
  },
  {
    date: "Lesedauer: 1 Sekunde",
    cat: "knapp",
    title: "Kunden lesen keine Gedanken",
    excerpt:
      "Sie stellen Fragen.",
    img: "https://public.readdy.ai/ai/img_res/edited_29ff06822b54d7404b10ac76fc32f2e1_5d914b01.jpg",
  },
  {
    date: "Lesedauer: 1 Sekunde",
    cat: "wahr",
    title: "Wachstum kommt selten von allein",
    excerpt:
      "Manchmal will es angerufen werden.",
    img: "https://public.readdy.ai/ai/img_res/edited_29ff06822b54d7404b10ac76fc32f2e1_16e21714.jpg",
  },
];

export default function Journal() {
  return (
    <section id="blog" className="relative py-32 md:py-48 px-6 md:px-12">
      <div className="max-w-7xl mx-auto">
        <div
          data-reveal
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16"
        >
          <div>
            <span className="text-xs tracking-[0.4em] uppercase text-moss mb-4 block">
              · BLOG
            </span>
            <h2 className="font-display text-4xl md:text-6xl font-light leading-tight">
              Der kürzeste Marketing-Blog <em className="italic text-sage">Deutschlands</em>
            </h2>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 md:gap-8">
          {entries.map((e, i) => (
            <article
              key={e.title}
              data-reveal
              data-delay={i + 1}
              className="group cursor-pointer"
            >
              <div className="aspect-[4/3] w-full rounded-2xl overflow-hidden border border-line mb-6">
                <img
                  src={e.img}
                  alt={e.title}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-700"
                />
              </div>
              <div className="flex items-center gap-3 text-xs text-inkDim mb-3">
                <span className="uppercase tracking-[0.2em] text-moss">
                  {e.cat}
                </span>
                <span className="w-1 h-1 rounded-full bg-inkDim/40" />
                <span>{e.date}</span>
              </div>
              <h3 className="font-display text-2xl md:text-3xl text-ink leading-snug mb-3 group-hover:text-sage transition-colors">
                {e.title}
              </h3>
              <p className="text-sm text-inkDim leading-relaxed">{e.excerpt}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}